// @ts-nocheck
import translate from "@insite/client-framework/Translate";
import TextField, { TextFieldPresentationProps } from "@insite/mobius/TextField";
import uniqueId from "@insite/mobius/utilities/uniqueId";
import {
    useOrderHistoryDebouncedUpdateDraftParameter,
    useOrderHistoryState,
} from "@store/Framework/Store/Greif/Pages/OrderHistory/OrderHistoryHooks";
import FilterDrawerSection from "@store/Library/Components/FilterDrawerSection";
import { filterDrawerProps } from "@store/Themes/common/props/filterDrawer";
import React, { FC, useEffect, useMemo, useState } from "react";

export interface OrderHistoryFilterFieldPoNumberProps {}

export interface OrderHistoryFilterFieldPoNumberStyles {
    textField?: TextFieldPresentationProps;
}

export const OrderHistoryFilterFieldPoNumberStyles: OrderHistoryFilterFieldPoNumberStyles = {
    textField: filterDrawerProps.textField,
};

const styles = OrderHistoryFilterFieldPoNumberStyles;

const OrderHistoryFilterFieldPoNumber: FC<OrderHistoryFilterFieldPoNumberProps> = () => {
    const { poNumber } = useOrderHistoryState().draftParameter;
    const debouncedUpdateDraftParameter = useOrderHistoryDebouncedUpdateDraftParameter();
    const [value, setValue] = useState(poNumber);
    const id = useMemo(uniqueId, []);
    const label = translate("PO #");

    useEffect(() => {
        if (value !== poNumber) {
            setValue(poNumber);
        }
    }, [poNumber]);

    return (
        <FilterDrawerSection title={label} labelFor={id}>
            <TextField
                {...styles.textField}
                id={id}
                data-test-selector="orderHistory_filterPONumber"
                onChange={event => {
                    setValue(event.currentTarget.value);
                    debouncedUpdateDraftParameter({ poNumber: event.currentTarget.value });
                }}
                placeholder={translate("Enter {0}", label)}
                value={value}
            />
        </FilterDrawerSection>
    );
};

export default OrderHistoryFilterFieldPoNumber;
